export function extractCommonButtonProps(_ref) {
  var disabled = _ref.disabled,
    href = _ref.href,
    icon = _ref.icon,
    label = _ref.label,
    loading = _ref.loading,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown;
  return {
    disabled: disabled,
    href: href,
    icon: icon,
    label: label,
    loading: loading,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur
  };
}